import { getNoticeBannersByFilterForUser } from "api/noticeBannerApi";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { orgSelector, userSelector } from "redux/selectors";
import { HiOutlineInformationCircle } from 'react-icons/hi';
import "./noticeBanner.scss"

const NOTICE_BANNER_DISMISS_KEY = 'notice_banner_dismissed_by_user';

const NoticeBanner = () => {
    const [t] = useTranslation();
    const [siteMessage, setSiteMessage] = useState<any>(null);
    const [orgMessage, setOrgMessage] = useState<any>(null);
    const {organizationId} = useSelector(orgSelector);
    const { userInfo } = useSelector(userSelector);
    const [isCloseSiteMessage, setIsCloseSiteMessage] = useState(true);
    const [isCloseOrgMessage, setIsCloseOrgMessage] = useState(true);

    const getDismissedState = () => {
        try {
            const data = localStorage.getItem(NOTICE_BANNER_DISMISS_KEY);
            return data ? JSON.parse(data) : {};
        } catch {
            return {};
        }
    };

    const getDismissedBannerId = (type: 'SITE' | 'ORGANIZATION') => {
        const userId = userInfo?.id;
        if (!userId) return null;
        const dismissedState = getDismissedState();
        if (type === 'SITE') return dismissedState?.[userId]?.site || null;
        if (!organizationId) return null;
        return dismissedState?.[userId]?.org?.[organizationId] || null;
    };

    const setDismissedBannerId = (type: 'SITE' | 'ORGANIZATION', bannerId?: string) => {
        const userId = userInfo?.id;
        if (!userId || !bannerId) return;
        if (type === 'ORGANIZATION' && !organizationId) return;
        const dismissedState = getDismissedState();
        const existingUserState = dismissedState?.[userId] || {};
        const existingOrgState = existingUserState?.org || {};

        const nextUserState = type === 'SITE'
            ? { ...existingUserState, site: bannerId }
            : { ...existingUserState, org: { ...existingOrgState, [organizationId]: bannerId } };

        localStorage.setItem(
            NOTICE_BANNER_DISMISS_KEY,
            JSON.stringify({ ...dismissedState, [userId]: nextUserState }),
        );
    };

    useEffect(() => {
        getNoticeBannersByFilterForUser({page: 0, limit: 1, type: "SITE", isActive: true}).then(res => {
            if (res?.data?.totalEntities > 0) {
                const latestBanner = res?.data?.entities[0];
                setSiteMessage(latestBanner);
                setIsCloseSiteMessage(getDismissedBannerId('SITE') !== latestBanner?.id);
            } else {
                setSiteMessage(null);
            }
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userInfo?.id])

    useEffect(() => {
        getNoticeBannersByFilterForUser({page: 0, limit: 1, type: "ORGANIZATION", organizationId, isActive: true }).then(res => {
            if (res?.data?.totalEntities > 0) {
                const latestBanner = res?.data?.entities[0];
                setOrgMessage(latestBanner);
                setIsCloseOrgMessage(getDismissedBannerId('ORGANIZATION') !== latestBanner?.id);
            } else {
                setOrgMessage(null);
            }
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [organizationId, userInfo?.id])

    const handleCloseSiteMessage = () => {
        setDismissedBannerId('SITE', siteMessage?.id);
        setIsCloseSiteMessage(false);
    };

    const handleCloseOrgMessage = () => {
        setDismissedBannerId('ORGANIZATION', orgMessage?.id);
        setIsCloseOrgMessage(false);
    };

    return (
        <>
            <div className="flex banner-full">
                {siteMessage && isCloseSiteMessage && (
                    <div className="notice-banner">
                        <div className="notice-banner-content">
                            <div className="notice-banner-label">
                                <HiOutlineInformationCircle size={16} />
                                <span>{t('noticeBannerPage.siteMessage')}</span>
                            </div>
                            <p className="notice-banner-message">{siteMessage.message}</p>
                        </div>
                        <button className="close-btn" onClick={handleCloseSiteMessage}>
                            <span>Clear</span>
                        </button>
                    </div>
                )}
                {orgMessage && isCloseOrgMessage && (
                    <div className="notice-banner">
                        <div className="notice-banner-content">
                            <div className="notice-banner-label">
                                <HiOutlineInformationCircle size={16} />
                                <span>{t('noticeBannerPage.orgMessage').replace('{OrgName}', orgMessage.organization?.name)}</span>
                            </div>
                            <p className="notice-banner-message">{orgMessage.message}</p>
                        </div>
                        <button className="close-btn" onClick={handleCloseOrgMessage}>
                            <span>Clear</span>
                        </button>
                    </div>
                )}
            </div>
        </>
    )
}

export default NoticeBanner;
